var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"appani"}},[_c('router-view')],1),_vm._v(" "),_c('videoDialog',{ref:"videoDialog"}),_vm._v(" "),_c('Dialogbox',{ref:"dialogbox"}),_vm._v(" "),_c('dialogMedia',{ref:"dialogMedia"}),_vm._v(" "),_c('qrcode',{ref:"qrcode"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d5289e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 